module.exports = __webpack_public_path__ + "img/imagePreviewEmptyState.acc1bb09.svg";